import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { Button } from "./ui/button";

// Mostra un pulsante "Installa app" quando il browser supporta l'installazione PWA.
// Su iOS Safari l'evento non esiste: l'utente usa Condividi -> Aggiungi a Home.
export function InstallPWA({ className = "", variant = "outline" }) {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => { setInstalled(true); setDeferred(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    if (window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone) {
      setInstalled(true);
    }
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed || !deferred) return null;

  const install = async () => {
    deferred.prompt();
    try { await deferred.userChoice; } catch (_) {}
    setDeferred(null);
  };

  return (
    <Button type="button" data-testid="install-pwa-button" onClick={install} variant={variant}
      className={`gap-2 ${className}`}>
      <Download className="w-4 h-4" /> Installa app
    </Button>
  );
}
